import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import { initializeStoreDiscount } from 'actions/FormActions';
import { discountOrder, discountVisitOrder } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import DialogHeader from 'screens/components/basic/DialogHeader';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};

class POSVisitDiscountDialog extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentWillReceiveProps = (newProps) => {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            // if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else if (newProps.saveSuccess === false && newProps.saveError) {
                const errorCode = newProps.saveError.split('-')[0];
                this.saveFailure(errorCode);
            }
        }
    }

    componentWillUnmount() {

    }

    saveSuccess = () => {
        this.onClose();
        this.props.showSnackbar(this.props.t('pos.discountDialog.saveSuccessMessage'));
    }

    saveFailure = (errorCode) => {
        if (errorCode && errorCode == 9) {
            this.props.showError(this.props.t('pos.messages.invalidCredentialsDiscount'));
        }
        else if(errorCode && errorCode == 4){
            this.props.showError(this.props.t('pos.messages.orderUpdatedElsewhereMessage'))
        }
        else {
            this.props.showError(this.props.t('pos.discountDialog.saveErrorMessage'));
        }
    }

    onClose = () => {
        this.props.onClose();
        this.props.initializeStoreDiscount();
    }

    applyDiscount = () => {
      const { stackDiscountsEnabled, discountOrder, order, branchId, visitCountDiscount, EmployeeId, pinCode, VisitDiscountUsername, VisitDiscountPassword } = this.props;
      const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
      if (stackDiscountsEnabled) {
        const model = {
          OrderId: order.id,
          UserName: VisitDiscountUsername || "",
          Password: VisitDiscountPassword || "",
          Percentage: 0,
          Amount: 0,
          BranchId: branchId,
          EmployeeId: EmployeeId,
          IsFromRewardPoints: false,
          CustomizedDiscountId: 0,
          PinCode: pinCode,
          DeviceId: deviceData.id,
          orderProductsDiscount: [],
          OrderDiscountVisit: {
            Amount: 0,
            Percentage: visitCountDiscount,
            Notes: `VistDiscount ${this.props.notes}`
          },
          CustomizedDiscountIds: [],
          IsFromVisitCount: true,
          RewardPoint: null,
          ModifiedDate: order.modifiedDate
        };
        discountOrder(model);
      } else {
        let model = {
          Id: this.props.order ? this.props.order.id : 0, BranchId: this.props.branchId,
          DeviceId: deviceData.id, Percentage: this.props.visitCountDiscount,
          Amount: 0, Notes: this.props.notes, OrderId: this.props.order ? this.props.order.id : 0,
          ModifiedDate: order.modifiedDate
        };
        this.props.discountVisitOrder(model);
      }
    }

    render() {
        const { t } = this.props; 
        const p = this.props;

        return (
            <DialogInput
                title={<DialogHeader text={`${t('pos.visitDiscountDialog.applyDiscount')} - ${t('common.order')} # ${this.props.order ? p.order.id : ""}`} classicClass="posDialogClassic"/>}
                modal={true}
                open={p.open}
                autoScrollBodyContent={true}
                contentStyle={dialogStyle}
                actions={[
                    <Button
                        key={2}
                        type="CancelButton"
                        name="buttonCancel"
                        className="btn-space"
                        label={t('common.cancel')}
                        onTouchTap={() => this.onClose()} />,
                    <Button
                        key={1}
                        name="addButton"
                        label={t('common.apply')}
                        primary={true}
                        className="btnNewBrandPOS"
                        onTouchTap={() => this.applyDiscount()} />
                ]}>

                    <div className="row">
                        <div className="col-lg-12">
                            <br />
                            <div className="pos-online-order-code">
                                <p className="purpleText">{t('pos.visitDiscountDialog.applyDiscountUsingPoints', { discount: this.props.visitCountDiscount, counts: this.props.visitCountsForDiscount})}</p>
                            </div>
                        </div>
                    </div>
                        {this.props.stackDiscountsEnabled &&
                        <div className="row">
                            <div className="col-lg-6">
                            <TextInput name={`VisitDiscountUsername`}
                                fullWidth={true}
                                label={t('common.mgmtTeamUserName')}
                                floatingLabelText={t('common.mgmtTeamUserName')}
                                hintText={t('common.mgmtTeamUserName')} />
                            </div>
                            <div className="col-lg-6">
                            <TextInput name={`VisitDiscountPassword`}
                                type="password"
                                fullWidth={true}
                                label={t('common.mgmtTeamPwd')}
                                floatingLabelText={t('common.mgmtTeamPwd')}
                                hintText={t('common.mgmtTeamPwd')} />
                            </div>
                        </div>}
                    <div className="row">
                        <div className="col-lg-12">
                            <br />
                            <TextInput
                                name={`${p.name}Notes`}
                                label={t('common.notes')}
                                hintText={t('common.notes')}
                                fullWidth={true}
                            />
                        </div>
                    </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        EmployeeId: state.entity.pin.employee.id || 0,
        notes: state.form[`${ownProps.name}Notes`],
        saveSuccess: state.form[`${ownProps.name}SaveSuccess`],
        saveError: state.form[`${ownProps.name}SaveError`],
        order: state.entity.posOrder,
        branchId: state.common.branchId,
        visitCountDiscount: state.common.applicationSettings.visitCountDiscount,
        visitCountsForDiscount: state.common.applicationSettings.visitCountsForDiscount,
        stackDiscountsEnabled: state.common.applicationSettings.stackDiscountsEnabled,
        pinCode: state.form.posDialogDiscountPinCode || "",
        VisitDiscountUsername: state.form.VisitDiscountUsername,
        VisitDiscountPassword: state.form.VisitDiscountPassword
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        discountVisitOrder: (model) => dispatch(discountVisitOrder(model, ownProps.name)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        initializeStoreDiscount: () => dispatch(initializeStoreDiscount(ownProps.name, 'POSProductDiscount')),
        discountOrder: (model) => dispatch(discountOrder(model, ownProps.name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSVisitDiscountDialog))